import './menu_panel_component.scss'
import { Controller } from 'stimulus'
import { createPopper } from '@popperjs/core'

export default class extends Controller {
  static targets = ['button', 'pane', 'count']
  static values = { identifier: String, position: String, label: String }
  static classes = ['open', 'active']

  connect = (): void => {
    this.paneTarget.classList.add(this.openClass)
    const depotMenuElement = this.element.closest('.depot_menu')
    this.popperInstance = createPopper(this.buttonTarget, this.paneTarget, {
      placement: `${String(this.positionValue)}-start`,
      modifiers: [
        {
          name: 'offset',
          options: {
            offset: [0, 6]
          }
        },
        {
          name: 'preventOverflow',
          options: {
            boundary: depotMenuElement
          }
        }
      ]
    })
    this.close()
  }

  showFloatingLabel = (event: Event): void => {
    if (this.label.length === 0) return
    this.floatingLabelController.show(this.label)
  }

  hideFloatingLabel = (event: Event): void => {
    this.floatingLabelController.hide()
  }

  updateFloatingLabel = (event: Event): void => {
    this.floatingLabelController.update(event)
  }

  toggle = (): void => {
    this.opened() ? this.close() : this.open()
  }

  open = (): void => {
    this.popperInstance.update()
    this.paneTarget.classList.add(this.openClass)
    this.buttonTarget.classList.add(this.openClass)
    this.paneTarget.setAttribute('data-show', '')

    if (this.childController() !== null) {
      this.childController().connect()
      this.focus()
    }
  }

  focus = (): void => {
    this.childController().focus()
  }

  close = (event: object): void => {
    if (this.eventHappenedOnPanel(event)) return
    this.paneTarget.classList.remove(this.openClass)
    this.buttonTarget.classList.remove(this.openClass)
    this.paneTarget.removeAttribute('data-show')
  }

  eventHappenedOnPanel = (event: object): boolean => {
    if (event === undefined) return false
    const targetAncestors: array = this.ancestorsForTarget(event)
    return targetAncestors.includes(this.element)
  }

  ancestorsForTarget = (event: object): array => {
    const ancestors = []
    let element = event.target
    ancestors.push(element)
    while (element.parentNode !== null) {
      ancestors.unshift(element.parentNode)
      element = element.parentNode
    }
    return ancestors
  }

  opened = (): boolean => {
    return this.paneTarget.classList.contains(this.openClass)
  }

  childController = (): object => {
    return this.application.getControllerForElementAndIdentifier(this.paneTarget.firstChild, this.identifierValue)
  }

  activate = (count: number = undefined): void => {
    this.buttonTarget.classList.add(this.activeClass)
    this.paneTarget.classList.add(this.activeClass)
    if (count !== undefined) {
      this.countTarget.innerHTML = count
    } else {
      this.countTarget.classList.add('small')
    }
  }

  deactivate = (): void => {
    this.buttonTarget.classList.remove(this.activeClass)
    this.paneTarget.classList.remove(this.activeClass)
    this.buttonTarget.classList.remove('small')
    this.countTarget.innerHTML = ''
  }

  get floatingLabelController (): object {
    return this.application.getControllerForElementAndIdentifier(document.getElementById('floating_label'), 'floating-label')
  }

  get label (): string {
    return this.labelValue
  }
}
